import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import { TOKEN_EDIT, TOKEN_INSERT } from 'data-token-picker/constants/PickerModes';
import { jsx as _jsx } from "react/jsx-runtime";
const BrowserTitlePropTypes = {
  mode: PropTypes.oneOf([TOKEN_INSERT, TOKEN_EDIT])
};
const BrowserTitle = ({
  mode
}) => {
  const titleKey = mode === TOKEN_INSERT ? 'data-token-picker.title.insert' : 'data-token-picker.title.edit';
  return /*#__PURE__*/_jsx(H4, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleKey
    })
  });
};
BrowserTitle.propTypes = BrowserTitlePropTypes;
BrowserTitle.displayName = 'BrowserTitle';
export default BrowserTitle;